export default "__VITE_ASSET__BDNPTcun__"